import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-facebook-icon/jb-facebook-icon.css.ts
var jb_facebook_icon_css_default = i`:host{display:block;height:var(--icon-height, 16px);width:var(--icon-width, 16px)}svg{height:var(--icon-height, 16px);width:var(--icon-width, 16px)}`;

export {
  jb_facebook_icon_css_default
};
